
export const RADAR_ACTIONS = [
  { label: 'Hard Block User', value: 'hard_block_user' },
  { label: 'Soft Block User', value: 'soft_block_user' },
  { label: 'Contact Support', value: 'contact_support' },
  { label: 'No Action', value: 'no_action' },
]

export const SYS_TYPE_OPTIONS = [
  { value: 'invalid_domains', label: 'Invalid', placeholder: 'Enter Invalid domains...' },
  { value: 'unknown_domains', label: 'Unknown', placeholder: 'Enter Unknown domains...' },
  { value: 'catch_all_domains', label: 'Catch All', placeholder: 'Enter Catch All domains...' }
];